import type { AppRouter } from "@tams-app/api/router";
import { createTRPCProxyClient, httpBatchLink } from "@trpc/client";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL?.trim();
const explicitTrpcUrl = import.meta.env.VITE_TRPC_URL?.trim();
const trpcUrl =
	explicitTrpcUrl && explicitTrpcUrl.length > 0
		? explicitTrpcUrl
		: supabaseUrl
			? `${supabaseUrl.replace(/\/+$/, "")}/functions/v1/trpc`
			: undefined;

export function hasTrpcConfig(): boolean {
	return Boolean(trpcUrl);
}

function requireTrpcUrl() {
	if (!trpcUrl) {
		throw new Error(
			"tRPC の環境変数が未設定です。VITE_TRPC_URL または VITE_SUPABASE_URL を設定してください。",
		);
	}

	return trpcUrl;
}

export function getTrpcClient(accessToken?: string | null) {
	const url = requireTrpcUrl();

	return createTRPCProxyClient<AppRouter>({
		links: [
			httpBatchLink({
				headers() {
					return accessToken
						? {
								Authorization: `Bearer ${accessToken}`,
							}
						: {};
				},
				url,
			}),
		],
	});
}
